export default __webpack_public_path__ + "static/media/acc-acq.fb912291.svg";